import posthog, { type Properties } from 'posthog-js'

import { type User } from '../types'

export const captureEvent = (event: string, properties?: Properties) => posthog.capture(event, properties)

export const identifyUser = (user: User) => posthog.identify(user._id, { ...user })
